<template>
  <nav class="nav-menu">
    <div class="nav-menu__list">
      <div class="nav-menu__item item-logo">
        <img :src="require('@/assets/img/Logo-mini.png')" alt="logo" />
      </div>
      <el-tooltip
        :open-delay="500"
        :content="route.meta.title"
        placement="right"
        popper-class="navigation-pooper"
        :class="[
          'nav-menu__item',
          currentRoute.path === route.path ? 'itemActive' : '',
        ]"
        v-for="route of routesColeection"
        :key="route.meta.id"
      >
        <router-link class="nav-menu__link" :to="route.path">
          <el-badge
            :value="badgeContent(route)"
            :hidden="badgeContent(route) ? false : true"
          >
            <v-icon
              class="nav-menu__icon"
              :class="{'iconActive': currentRoute.path === route.path}"
              :name="route.meta.icon"
            />
          </el-badge>
        </router-link>
      </el-tooltip>
      <el-tooltip
        popper-class="navigation-pooper"
        class="nav-menu__item"
        content="Выход"
        placement="right"
        :open-delay="500"
      >
        <button class="nav-menu__logout-btn" @click="signOut()">
          <v-icon class="nav-menu__icon" name="logout" />
        </button>
      </el-tooltip>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import teacherTab from "../components/navTabs/teacherTab";
import pageTab from "../components/navTabs/pageTab";
export default {
  name: "navigation",
  data() {
    return {
      tabTitle: "test",
      user: {
        name: "noname",
        id: 0,
        properties: {
          countUnreadMsg: "",
          countDisciplines: "",
          countUntestedWorks: "",
        },
      },
      curentSubMenuData: [],
      routesColeection: [],
    };
  },
  components: {
    "teacher-tab": teacherTab,
    "page-tab": pageTab,
  },
  methods: {
    ...mapActions({
      signOut: "auth/signOut",
      guardian: "guardian",
    }),
    ...mapMutations(["setdashBordActive"]),
    badgeContent(value) {
      if (value.name === "Messages") {
        return this.user.properties.countUnreadMsg;
      } else if (value.name === "tresult") {
        return this.user.properties.countUntestedWorks;
      } else if (value.name === "Docs") {
        return this.$store.getters["docs/unviewedCount"];
      }
    },
    dashBordFunc(value) {
      value === this.currentRoute.path ? this.setdashBordActive() : null;
    },
    setSubmenu(findId) {
      let result = this.menuItems.find((el) => el.meta.id === findId);
      return result.children;
    },
  },
  computed: {
    pageTab() {
      return this.$store.state.pageTab;
    },
    currentRoute() {
      return this.$store.state.currentRoute;
    },
  },
  mounted() {
    this.$router.options.routes.forEach((el) => {
      el.meta.nav ? this.routesColeection.push(el) : null;
    });
  },
};
</script>

<style lang="scss">
.nav-menu {
  margin-left: 10px;
  margin-top: 20px;
  flex-shrink: 0;
  transition-duration: 0.3s;
  transition-property: width;
  position: relative;
  height: 100%;
  width: 80px;
  .nav-menu-item__central-wrp {
    width: 100%;
  }
  .nav-menu__list {
    border-radius: 50px 50px 0 0;
    position: absolute;
    left: 0;
    z-index: 3;
    width: 80px;
    background-color: $brand-clr-1;
    height: 100%;
    display: grid;
    grid-template-rows: 80px repeat(auto-fit, 60px);
    align-items: center;
    justify-items: center;
  }
  .nav-menu__item {
    cursor: pointer;
    transition-property: box-shadow background-color;
    transition-duration: 0.3s;
    height: 100%;
    width: 100%;
    box-shadow: inset 0 0 0 darken($brand-clr-1, 5%);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .item-logo {
    overflow: hidden;
    width: 60px;
    height: 60px;
    background-color: white;
    border-radius: 50%;
    padding-bottom: 5px;
    img {
      width: 40px;
    }
  }
  .item-logo-active {
    background-color: #c0c4cc;
  }
  .nav-menu__link {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .nav-menu__link-corner {
    position: absolute;
    width: 60px;
    height: 60px;
    border: 1px solid red;
    fill: white;
  }
  .nav-menu__icon {
    transition-duration: 0.2s;
    width: 25px;
    color: $basic-white;
    transform: scale(1);

    &.iconActive {
      color: $brand-clr-1;
      transform: scale(0.9);
    }
  }
  .itemActive {
    width: 85%;
    margin-left: 13px;
    border-radius: 15px 0 0 15px;
    background-color: $basic-white;
  }
  .iconActive {
    transform: scale(0.9);
  }
  .nav-menu__logout-btn {
    border: none;
    background-color: transparent;
    cursor: pointer;
    outline: none;
    color: $info-clr;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}
.navigation-pooper {
  outline: none;
  background-color: $brand-clr-1 !important;
  .popper__arrow::after {
    border-right-color: $brand-clr-1 !important;
  }
  .popper__arrow::before {
    border-right-color: $brand-clr-1 !important;
  }
}

@media (max-width: 400px) {
  .nav-menu {
    width: 100%;
  }
}
</style>
